import { Link } from "@components/Link/Link";
import { StyledContainer } from "@components/Styled/Container";
import { clsx } from "clsx";
import { StyledH3, StyledH5 } from "@components/Styled/Text";
import React from "react";
import SwiperCore, { Scrollbar } from "swiper";
import { SwiperSlide } from "swiper/react";

import { withCollectionButtonSlider } from "./withCollectionButtonSlider";
import Container from "@components/Atomic/Container/Container";

SwiperCore.use([Scrollbar]);

import Swiper from "@components/Swiper/Swiper";

const GliderWrapper = (props: any) => <div {...props} />;

const Title = (props: any) => <StyledH3 {...props} />;

const SubTitle = (props: any) => (
  <StyledH5
    {...props}
    className={clsx(props.className, "mb-midi text-center")}
  />
);
const SectionHeader = (props: any) => (
  <section
    {...props}
    className={clsx(props.className, "px-micro pt-mega text-center md:px-mega")}
  />
);
const SectionWrapper = (props: any) => <section {...props} />;

const Button = (props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "block w-full px-[1px] py-mini text-center no-underline hover:bg-black hover:text-white focus-visible:!outline-offset-[-1px]",
      props.active ? "bg-black text-white" : "bg-tertiary text-primary",
    )}
  />
);

const slides = {
  center: {
    480: {
      slidesPerView: 3.5,
      spaceBetween: 8,
    },
    640: {
      slidesPerView: 4.5,
      spaceBetween: 8,
    },
    1024: {
      slidesPerView: 6.5,
      spaceBetween: 8,
    },
    1200: {
      slidesPerView: 8,
      spaceBetween: 8,
    },
  },
  left: {
    480: {
      slidesPerView: 3.5,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 4.5,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 6.5,
      spaceBetween: 10,
    },
    1200: {
      slidesPerView: 8.5,
      spaceBetween: 10,
    },
  },
};

const CollectionButtonSlider = withCollectionButtonSlider(
  ({
    isActiveCollection,
    titleLink,
    subtitle,
    sectionLinks,
    alignment,
    styles,
  }) => {
    return (
      <Container
        styles={styles}
        data-component-type="section-collection-button-slider"
      >
        <StyledContainer width="xl">
          {titleLink?.title ? (
            <SectionHeader>
              <Title>
                <Link to={titleLink?.url} className="no-underline">
                  {titleLink?.title}
                </Link>
              </Title>
              <SubTitle>{subtitle}</SubTitle>
            </SectionHeader>
          ) : null}
          <SectionWrapper>
            <GliderWrapper alignment={alignment} count={sectionLinks?.length}>
              <Swiper
                slidesPerView={2.5}
                spaceBetween={10}
                scrollbar={{ draggable: true }}
                style={{ paddingBottom: "1.25rem" }}
                observer={true}
                observeParents={true}
                breakpoints={{
                  480: {
                    ...slides[alignment ?? "left"]["480"],
                    observer: true,
                    observeParents: true,
                  },
                  640: {
                    ...slides[alignment ?? "left"]["640"],
                    observer: true,
                    observeParents: true,
                  },
                  1024: {
                    ...slides[alignment ?? "left"]["1024"],
                    observer: true,
                    observeParents: true,
                  },
                  1200: {
                    ...slides[alignment ?? "left"]["1200"],
                    observer: true,
                    observeParents: true,
                  },
                }}
              >
                {sectionLinks?.map((section: any, index: any) => (
                  <SwiperSlide key={index}>
                    <Button
                      {...section}
                      to={section.link?.url}
                      active={isActiveCollection(
                        section.link?.url,
                        section.link?.title,
                      )}
                      alignment={alignment}
                    >
                      {section.title}
                    </Button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </GliderWrapper>
          </SectionWrapper>
        </StyledContainer>
      </Container>
    );
  },
);
export default CollectionButtonSlider;
